module.exports = require("./lib/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/polyfill.js
 ** module id = 534
 ** module chunks = 0
 **/